 <template>
  <!--
    Purpose of this component is to init subscription data if not done yet
    before entering Subscription.
  -->
  <section>
    <Subscription></Subscription>
  </section>
</template>

<script>
import doRequest from '@/api/dssRequest';
import Subscription from '@/components/subscription/Subscription';

export default {
  name: 'EventSubscription',
  components: {
    Subscription,
  },
  computed: {
    userId() {
      return this.$store.getters['auth/userObjectId'];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.commit('subscription/clear');
      this.getEventDetails();
    },
    getEventDetails() {
      const payload = {
        EventId: this.$route.params.event_id,
      };

      doRequest(
        (response) => {
          const eventDetails = response.data;

          this.$store.commit('subscription/setEvent', eventDetails);

          if (eventDetails != null
            && eventDetails.SuggestionMap != null
            && eventDetails.SuggestionMap.Products != null
          ) {
            this.$store.commit('subscription/setAllProducts', eventDetails.SuggestionMap.Products);
          }
        },
        () => {},
        'getEventDetails',
        this.userId,
        payload,
        'GET',
      );
    },
  },
};
</script>
